document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var minQty = parseInt(root.dataset.minQty, 10) || 2;
  var pct = parseFloat(root.dataset.percent) || 0;
  var currency = root.dataset.currency || 'EUR';
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });
  var variant = root.querySelector('[data-variant]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var unitEl = root.querySelector('[data-unit-price]');
  var totalEl = root.querySelector('[data-total]');
  var savingEl = root.querySelector('[data-saving]');

  function unitCents() {
    if (variant.tagName === 'SELECT') {
      return parseInt(variant.options[variant.selectedIndex].dataset.price, 10);
    }
    return parseInt(variant.dataset.price, 10);
  }
  function update() {
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var unit = unitCents();
    var sum = unit * qty;
    var discount = qty >= minQty ? Math.round(sum * pct / 100) : 0;
    unitEl.textContent = fmt.format(unit / 100);
    totalEl.textContent = fmt.format((sum - discount) / 100);
    if (discount > 0) {
      savingEl.hidden = false;
      savingEl.textContent = 'Du sparst ' + fmt.format(discount / 100) + ' (' + pct + ' %)';
    } else {
      savingEl.hidden = true;
    }
  }
  root.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10);
      qtyInput.value = Math.max(1, v);
      update();
    });
  });
  qtyInput.addEventListener('input', update);
  variant.addEventListener('change', update);

  var main = document.getElementById('main-img');
  root.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = t.dataset.full;
    });
  });
  update();
});
